<div class="context-menu shadow-heavy">
    <div class="context-menu-header padding-y-m padding-x-l">
        <h3 class="p-semibold text-primary">{{ title }}</h3>
        <button class="close-btn padding-s" type="button" aria-label="Cerrar" (click)="onCancel()">
            <img src="assets/icons/cruz.svg" class="icon-20 icon-white" alt="Rechazar">
        </button>
    </div>

    <div class="context-menu-actions padding-y-sm">
        @for (option of options; track option.id) {
        <button class="action-btn padding-y-m padding-x-l" [ngClass]="getOptionTypeClass(option)" type="button"
            (click)="onOptionSelect(option)">
            @if (option.iconSrc) {
            <img [src]="option.iconSrc" class="action-icon icon-20 icon-text-secondary" alt="">
            }
            <span class="p">{{ option.label }}</span>
        </button>
        }
    </div>
</div>